import React, {useRef, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContentGroupByName} from "../../api/contentGroups";
import ImageCard from "../../components/ImageCard";
import Button from "@mui/material/Button";
import {AddRounded} from "@mui/icons-material";
import ContentNavigator from "../../components/ContentNavigator";
import ContentView from "../../components/ContentView";

const EtfTemplates = ({ onSelectGroup }) => {
  const dispatch = useDispatch();
  const groups = useSelector((state) => state.contentGroups.groups?.etfMatrixGroups);

  useEffect(() => {
      dispatch(fetchContentGroupByName('etfMatrixGroups'));
  }, [dispatch]);
  const sectionConfig = [
            {
                title: "Key Concepts",
                items: [
                    {
                        title: "Hidden Risks in ETFs",
                        text: "Understand the risks associated with ETFs covering overlap, weight skew and more",
                        onClick: () => console.log("Clicked: SMA vs ETFs")
                    },
                ]
            },
  ];
  const linksConfig = [
            {label: "Discussion on Overalp"},
            {label: "ETFs vs Stock SMAs"},
  ];



  const ContentScroll = ()=>(
      <>
          {groups && Array.isArray(groups) && groups.length > 0 && groups.map(group => (
              <ImageCard description={group?.fields?.description}
                               title={group?.fields?.name} imgUrl={group?.fields?.imgUrl}
                               action={
                                <Button startIcon={<AddRounded/>} variant={'outlined'} onClick={() => onSelectGroup(group.fields.etfs)}>
                                    View Now
                                </Button>
                               }

              />
        ))}
      </>
  )

  return (
      <ContentView content={<ContentScroll/>} navigator={<ContentNavigator linksConfig={linksConfig} sectionsConfig={sectionConfig} />}/>
  );
};

export default EtfTemplates;
